<template>
  <div class="index" id="anchor">
    <Seacher></Seacher>
    <div class="tranbox">
      <div class="tranboxtit">Contracts</div>
      <div class="indexbox">
        <div class="iboxleft">
          <div class="iboxtit">Contracts</div>
          <div class="iboxcon">
            {{ Number(currentContractCount).toLocaleString() }}
          </div>
          <div class="iboxbottom">
            <div class="ibttol">
              +{{ Number(lastDayContractCount).toLocaleString() }}
            </div>
            <div class="ibttor">Last 24h</div>
          </div>
        </div>
      </div>
      <div class="indexbox">
        <div class="iboxleft">
          <div class="iboxtit">Contract calls</div>
          <div class="iboxcon">
            {{ Number(currentCallCount).toLocaleString() }}
          </div>
          <div class="iboxbottom">
            <div class="ibttol">
              +{{ Number(lastDayCallCount).toLocaleString() }}
            </div>
            <div class="ibttor">Last 24h</div>
          </div>
        </div>
      </div>
      <div class="trancharts">
        <div class="charts_tit">
          <div class="charts_l">
            24h Top Contracts
            <el-tooltip placement="right" popper-class="toolTipClass">
              <div slot="content">
                Top 7 smart contracts by the number of calls in <br />the past
                24 hours across the network
              </div>
              <img src="@/assets/m/home/tip.png" />
            </el-tooltip>
            <!-- <img src="../../assets/m/home/tip.png" /> -->
          </div>
          <!-- <div class="charts_btn">
            <span> More</span> <img src="../../assets/m/home/more.png" />
          </div> -->
        </div>
        <div class="charts" v-if="callViewList.length <= 0">
          <img
            style="width: 300px; height: 200px"
            src="@/assets/pc/BkHash/zanwushuju.png"
          />
        </div>
        <div class="charts">
          <div id="charts" ref="chart" style="height: 230px"></div>
          <div class="chartsul">
            <div
              class="chartli"
              v-for="(item, index) in callViewList.slice(0, 7)"
              :key="index"
            >
              <div class="chartlil">
                <span class="markers"></span>

                <span v-if="item.contractName !== ''">{{
                  item.contractName
                }}</span>
                <span v-else>{{ getSubStr(item.contractAddress, 0, 3) }}</span>
              </div>
              <div class="chartlir">
                <span>
                  {{
                    new Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                      maximumFractionDigits: 10,
                    }).format(item.count)
                  }}
                  calls </span
                ><span>({{ parseFloat(item.sums).toFixed(2) }}%)</span>
              </div>
            </div>
            <!-- <div class="chartli">
              <div class="chartlil"><span class="markers"></span><span>USDT Token</span></div>
              <div class="chartlir">
                <span>1,854,499 calls </span><span>(97.32%)</span>
              </div>
            </div>
            <div class="chartli">
              <div class="chartlil"><span class="markers"></span><span>USDT Token</span></div>
              <div class="chartlir">
                <span>1,854,499 calls </span><span>(97.32%)</span>
              </div>
            </div>
            <div class="chartli">
              <div class="chartlil"><span class="markers"></span><span>USDT Token</span></div>
              <div class="chartlir">
                <span>1,854,499 calls </span><span>(97.32%)</span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- translist start -->
    <div class="translist">
      <div class="Block_Top notranslate">
        <span class="notranslate">Contracts</span>
      </div>
      <div class="resume-list">
        <div class="pool_main">
          <div class="tags">
            <div class="indexList">
              <div class="Block_list">
                <ul class="block_list_Top">
                  <li>Contract</li>
                  <li>Number of Calls</li>
                  <li class="xila">Deployer</li>
                  <li>Created on</li>
                </ul>
              </div>
              <div class="Block_List_center notranslate">
                <!-- contractList -->
                <ul>
                  <li v-for="(item, index) in contractList" :key="index">
                    <p @click="goDetail('hash', item)">
                      {{ item.contractAddress }}
                    </p>
                    <p>{{ Number(item.callNums).toLocaleString() }}</p>
                    <p @click="goDetail('transfer', item)">
                      {{ item.ownerAddress }}
                    </p>
                    <p>{{ item.tradeTime }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="block">
          <el-pagination
            background
            small
            :current-page.sync="pageNum"
            :page-size="20"
            :pager-count="5"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="total1"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- translist end -->
  </div>
</template>

<script>
const echarts = require("echarts");
import Seacher from "@/components/m/Seacher.vue";
import { GetContractList } from "@/assets/server/api";
import { formatSeconds, listTypea, getSubStr } from "../../utils/utils.js";
export default {
  components: {
    Seacher,
  },
  data() {
    return {
      pageSize: 1,
      total1: null,
      pageNum: 1,
      pagerCount: 0,
      transferList: [],
      //列表开始
      callViewList: [],
      contractList: [],
      currentCallCount: "",
      currentContractCount: "",
      lastDayCallCount: "",
      lastDayContractCount: "",
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  created() {
    this.pageNum = 1;
  },
  mounted() {
    // this.getTradeList();
    this.getContractTxList();
  },
  destroyed() {},
  methods: {
    getSubStr(str) {
      var subStr1 = str.substr(0, 5);
      var subStr2 = str.substr(str.length - 5, 5);
      var subStr = subStr1 + "..." + subStr2;
      return subStr;
    },
    goDetail(name, query) {
      console.log(query);
      switch (name) {
        case "hash":
          if (query.standard == "ERC-20") {
            console.log(111);
            let params = {
              contractAddress: query.contractAddress1,
            };
            this.$router.push({ path: "/m/Overaddress", query: params });
          } else if (query.standard == "ERC-721") {
            let params = {
              contractAddress: query.contractAddress1,
            };
            this.$router.push({ path: "/m/NftOveraddress", query: params });
          }

          break;
        case "transfer":
          this.$router.push({
            path: "/m/Address",
            query: { address: query.ownerAddress1 },
          });
          break;
      }
    },
    initCharts() {
      // var data = [
      //   { value: 1048, name: "USDT Token" },
      //   { value: 735, name: "LF8iBW9y1KL...pMszf" },
      //   { value: 580, name: "FTH-DC Token" },
      //   { value: 484, name: "DCT Token" },
      //   { value: 300, name: "LFdko4yMVrK...9D7iA" },
      //   { value: 300, name: "S-USDT-TRX Token" },
      //   { value: 300, name: "USDT Tokena" },
      // ];
      var colors=[];
      var data = [];

      // if (this.callViewList.length > 7) {
      //   this.callViewList = this.callViewList.slice(0, 7);
      // }
      // console.log(this.callViewList1);
      // console.log(this.callViewList);
      var totalValue = 0;
      for (var i = 0; i < this.callViewList.slice(0, 7).length; i++) {
        totalValue += this.callViewList[i].count; // 累加count值
        if (this.callViewList[i].count == 0) {
          colors = [
            "#8d8d8d",
            "#8d8d8d",
            "#8d8d8d",
            "#8d8d8d",
            "#8d8d8d",
            "#8d8d8d",
            "#8d8d8d",
          ];
        } else {
          colors = [
            "#00E79A",
            "#FFC302",
            "#A952FF",
            "#48D3E2",
            "#F76C9C",
            "#7C9FFC",
            "#9E3820",
          ];
        }
        data.push({
          value: this.callViewList[i].count,
          name: this.callViewList[i].contractName,
          itemStyle: {
            color: colors[i % colors.length], // 直接在这里分配颜色
          },
        });
      }
     if (this.callViewList.length > 7) {
        data.push({
          value: Number(this.lastDayCallCount) - Number(totalValue),
          name: "Other",
          itemStyle: {
            color: "#8d8d8d", // 可以为总和指定一个不同的颜色
          },
        });
     }
      // console.log(data);
      // console.log(Number(this.lastDayCallCount) - Number(totalValue));
      // console.log(data);

      this.lineChart = echarts.init(this.$refs.chart);
      let option = {
        tooltip: {
          // trigger: "item",
          confine: true,
          backgroundColor: "rgba(36,41,49,0.9)", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          // borderWidth: "1", //边框宽度设置1
          // borderColor: "gray", //设置边框颜色
          formatter: function (params) {
          //  console.log(params);
            let str =
              '<p style="padding-top:10px;text-align:left;">' +
              "<span style='color:#8d8d8d'>" +
              params.marker +
              "Contract :" +
              params.data.name +
              "</span>" +
              "<br/>" +
              '<span style="color:#8d8d8d;font-size:12px;margin-left:16px">' +
              "Number of Calls :" +
              '<span style="color:#fff">' +
              new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                maximumFractionDigits: 10,
              }).format(params.data.value) +
              "</span>" +
              "</span>" +
              "<br/>" +
              '<span style="color:#8d8d8d;margin-left:16px">' +
              "Percentage :" +
              '<span style="color:#fff">' +
              params.percent +
              "%" +
              "</span>" +
              "</span>" +
              "</p>";
            return str;
          },
        },
        // legend: {
        //   orient: "vertical",
        //   x: "2%", //可设定图例在左、右、居中
        //   y: "40%",
        //   icon: "circle",
        //   padding: [0, 10, 0, 0],
        //   itemHeight: 6, // 图例icon高度
        //   itemWidth: 6, // 图例icon宽度
        //   align: "left", // 图例icon在左侧
        //   formatter: function (name) {
        //          // 添加
        //     let total = 0;
        //     let target;
        //     for (let i = 0; i < data.length; i++) {
        //       total += data[i].value;
        //       if (data[i].name === name) {
        //         target = data[i].value;
        //       }
        //     }
        //     if(target==0){
        //       var arr = [
        //       "{a|" + name + "}",

        //       "{c|" + target + " " + "calls" + "}",

        //       "{b|" + 0 + "%}",
        //     ];
        //     return arr.join("  ");
        //     }else{
        //     var arr = [
        //       "{a|" + name + "}",

        //       "{c|" + target + " " + "calls" + "}",

        //       "{b|" + ((target / total) * 100).toFixed(2) + "%}",
        //     ];
        //     return arr.join("  ");
        //     }
        //   },
        //   textStyle: {
        //     // 添加
        //     padding: [8, 0, 0,10],
        //     rich: {
        //       a: {
        //         fontSize: 12,
        //         width: 120,
        //         color: "#fff",
        //       },
        //       b: {
        //         fontSize: 12,
        //         width: 60,
        //         color: "#c1c1c1",
        //       },
        //       c: {
        //         fontSize: 12,
        //         color: "#fff",
        //         width: 80,
        //       },
        //     },
        //   },
        // },
        graphic: [
          {
            type: "text",
            left: "40%",
            top: "35%",
            style: {
              text: "Total\n",
              textAlign: "center", //水平居中
              fill: "#91979D", //字体颜色
              width: 50,
              height: 30,
              font: '16px "STHeiti"', //字体大小
            },
          },
          {
            type: "text",
            left: "38%",
            top: "45%",
            style: {
              text: new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                maximumFractionDigits: 10,
              }).format(this.lastDayCallCount),
              // text: data.reduce((n, i) => {
              //   return (n += i.value);
              // }, 0),

              textAlign: "center",
              fill: "#fff",
              width: 60,
              height: 30,
              fontSize: 20,
            },
          },
          {
            type: "text",
            left: "40%",
            top: "55%",
            style: {
              text: "Calls\n",
              textAlign: "center", //水平居中
              fill: "#91979D", //字体颜色
              width: 50,
              height: 30,
              font: '16px "STHeiti"', //字体大小
            },
          },
        ],
        color: colors,
        series: [
          {
            // name: "Access From",
            type: "pie",
            radius: ["45%", "65%"],
            center: ["46%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            label: {
              normal: {
                show: true,
                position: "center",
                hoverAnimation: false,
                scale: false,
                textStyle: {
                  fontSize: 15,
                  color: "#00A870",
                  hoverAnimation: false,
                },
                emphasis: {
                  scale: false,
                  hoverAnimation: false,
                  label: {
                    show: false,
                    fontSize: "12",
                    fontWeight: "bold",
                  },
                },
              },
            },

            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 12,
                fontWeight: "bold",
              },
            },
            data: data,
          },
        ],
      };
      this.lineChart.setOption(option);
    },

    async getContractTxList() {
      let formData = new FormData();
      let params = {
        pageNum: this.pageSize,
        pageSize: 20,
      };
      //  console.log(params);
      let item = params;

      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GetContractList(formData);
        // console.log(res);
      this.callViewList = res.result.callViewList;
      this.lastDayCallCount = res.result.lastDayCallCount;
      var suma = this.callViewList.reduce((n, i) => {
        return (n += i.count);
      }, 0);
      for (var j = 0; j < this.callViewList.length; j++) {
        // this.callViewList[j].sums =
        //   parseFloat(this.callViewList[j].count / Number(this.lastDayCallCount)) * 100;
        this.callViewList[j].sums =
          parseFloat(this.callViewList[j].count / parseInt(suma)) * 100;
        if (this.callViewList[j].count == 0) {
          this.callViewList[j].sums = 0;
        }
      }
      //     console.log(this.callViewList);
      this.contractList = res.result.contractList;
      //    console.log(this.contractList);
      var calctime = new Date();
      let strdate = Math.floor(calctime.getTime() / 1000);
      for (var i = 0; i < this.contractList.length; i++) {
        this.contractList[i].ownerAddress1 =
          this.contractList[i].ownerAddress;
        this.contractList[i].ownerAddress = getSubStr(
          this.contractList[i].ownerAddress,
          0,
          3
        );
        this.contractList[i].contractAddress1 =
          this.contractList[i].contractAddress;
        this.contractList[i].contractAddress = getSubStr(
          this.contractList[i].contractAddress,
          0,
          3
        );
        let timestamp = Math.floor(this.contractList[i].tradeTime / 1000);
        var s = strdate - timestamp;
        if (s <= 0) {
          s = 1;
        }
        this.contractList[i].tradeTime = formatSeconds(s);
      }
      this.currentCallCount = res.result.currentCallCount;
      this.currentContractCount = res.result.currentContractCount;
      this.lastDayCallCount = res.result.lastDayCallCount;
      this.lastDayContractCount = res.result.lastDayContractCount;
      this.total1 = res.result.contractCount;
      if (this.callViewList.length > 0) {
        this.initCharts();
      }
    },
    handleCurrentChange(val) {
      this.pageSize = val;

      this.getContractTxList();
    },
  },
};
</script>
<style lang="less">
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #22252e;
  color: #fff;
  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  border: none;
}
.el-pager li {
  margin: 0px 6px !important;
  padding: 0px 6px !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  background: none;
  color: #adb0c7;
  width: 10px !important;
}

.el-pagination.is-background .el-pager li {
  padding-left: 6px;
  padding-right: 6px;
  height: 48px;
  margin: 0 10px;
  //background: #3c485c;
  background: none;
  border-radius: 8px;
  opacity: 1;

  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 48px;

  text-align: center;
}
</style>

<style lang="less" scoped>
.el-pagination {
  padding-bottom: 32px !important;
}
.index {
  width: 750px;
  margin: 110px auto 0px auto;
  background: #13161b;
  text-align: center;
  .tranbox {
    width: 702px;
    // height: 1507px;
    background: #000000;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    margin: 0 auto;
    padding-bottom: 24px;
    .tranboxtit {
      text-align: left;
      height: 42px;
      font-size: 30px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 42px;
      padding-top: 24px;
      margin-left: 24px;
      margin-bottom: 48px;
    }
    .indexbox {
      width: 654px;
      height: 208px;
      background: #13161b;
      border-radius: 24px 24px 24px 24px;
      opacity: 1;
      margin: 0 auto;
      display: flex;
      margin-bottom: 24px;
      justify-content: space-between;
      .iboxleft {
        margin-left: 24px;
        .iboxtit {
          margin-top: 24px;
          height: 34px;
          text-align: left;
          font-size: 24px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #8a8a8a;
          line-height: 34px;
        }
        .iboxcon {
          height: 62px;
          font-size: 44px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 62px;
          margin-bottom: 24px;
          margin-top: 2px;
          text-align: left;
        }
        .iboxbottom {
          display: flex;
          .ibttol {
            height: 34px;
            font-size: 24px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #00e79a;
            line-height: 34px;
          }
          .ibttor {
            margin-left: 16px;
            height: 34px;
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #8a8a8a;
            line-height: 34px;
          }
        }
      }
      .iboxright {
        margin-right: 24px;
        img {
          margin-top: 64px;
          width: 84px;
          height: 84px;
        }
      }
    }
    .trancharts {
      width: 654px;
      // height: 899px;
      background: #13161b;
      border-radius: 16px 16px 16px 16px;
      opacity: 1;
      margin: 0 auto;
      .charts_tit {
        display: flex;
        justify-content: space-between;
        padding-top: 24px;
        .charts_l {
          margin-left: 24px;
          height: 42px;
          font-size: 30px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #8a8a8a;
          line-height: 42px;
          img {
            width: 40px;
            height: 40px;
            margin-top: 4px;
          }
        }
        .charts_btn {
          margin-right: 24px;
          width: 127px;
          height: 44px;
          background: #000000;
          border-radius: 13px 13px 13px 13px;
          opacity: 1;
          span {
            font-size: 24px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            margin-left: 20px;
          }
          img {
            width: 40px;
            height: 40px;
          }
        }
      }
      .charts {
        .chartsul {
          width: 654px;
          margin: 0 auto;
          // margin-top: 44px;
          padding-bottom: 24px;
          .chartli:nth-child(1) {
            .markers {
              background: #00e79a;
            }
          }
          .chartli:nth-child(2) {
            .markers {
              background: #ffc302;
            }
          }
          .chartli:nth-child(3) {
            .markers {
              background: #a952ff;
            }
          }
          .chartli:nth-child(4) {
            .markers {
              background: #48d3e2;
            }
          }
          .chartli:nth-child(5) {
            .markers {
              background: #f76c9c;
            }
          }
          .chartli:nth-child(6) {
            .markers {
              background: #7c9ffc;
            }
          }
          .chartli:nth-child(7) {
            .markers {
              background: #9e3820;
            }
          }
          .chartli {
            height: 56px;
            font-size: 28px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #898b8d;
            line-height: 56px;
            display: flex;
            justify-content: space-between;
            margin-left: 26px;
            margin-right: 24px;
            // padding-bottom: 24px;
            .chartlil {
              display: flex;
              span {
                display: block;
              }
              .markers {
                display: block;
                width: 12px;
                height: 12px;

                opacity: 1;
                border-radius: 50%;
                margin-top: 20px;
                margin-right: 6px;
              }
            }
            .chartlir {
              span:nth-child(2) {
                color: #fff;
                font-size: 28px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
              }
            }
          }
        }
      }
    }
  }
  .translist {
    width: 100%;
    overflow: hidden;
    margin-top: 24px;
    background: #13161b;
    .Block_Top {
      text-align: left;
      width: 702px;
      height: 80px;
      line-height: 80px;
      margin: 0 auto;
      background: #0b0c0f;
      border-radius: 24px 24px 0 0;
      span {
        font-size: 30px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-left: 24px;
      }
      b {
        margin-left: 10px;
      }
    }
    //轮播图片开始
    .resume-list {
      width: 702px;
      background: #0b0c0f;
      border-radius: 0 0 24px 24px;
      margin: 0 auto;
      .pool_main {
        width: 100%;
      }
      .tags {
        display: flex;
        overflow: auto;
        white-space: nowrap;
      }
      //隐藏滚动条
      .tags::-webkit-scrollbar {
        display: none;
      }
      // 列表开始
      .indexList {
        width: 100%;
        margin: 0;
        padding: 0;
        background: #0b0c0f;
        .Block_list {
          .block_list_Top {
            display: flex;
            width: 1300px;
            height: 82px;
            line-height: 82px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              // border: 1px solid red;
              margin-left: 24px;
              width: 300px;
            }
            li:nth-child(2) {
              width: 300px;
            }
            li:nth-child(3) {
              width: 300px;
            }
            li:nth-child(4) {
              width: 400px;
            }
          }
        }
        .Block_List_center {
          width: 1300px;
          ul {
            //  height: 620px;
            width: 1300px;
            margin: 0;
            padding: 0;
            //padding: 0 19px;
            li {
              display: flex;
              height: 82px;
              border-bottom: 1px solid #22252e;
              line-height: 82px;
              margin-left: 24px;
              // width: 200px;
              p {
                font-size: 26px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                text-align: left;
                // flex: 0 0 14%;
              }
            }
            li:last-child {
              //  border-bottom: none;
            }
            p:nth-child(1) {
              width: 300px;
              // border: 1px solid red;
            }
            p:nth-child(2) {
              width: 300px;
              color: #8a8a8a;
            }
            p:nth-child(3) {
              width: 300px;
            }
            p:nth-child(4) {
              width: 400px;
              color: #8a8a8a;
            }
          }
        }
      }
      .block {
        margin-top: 70px;
        padding-bottom: 70px;
        font-size: 28px;
        font-family: "PingFang SC-中黑体, PingFang SC";
        font-weight: normal;
        color: #adb0c7;
        // line-height: 39px;
      }
    }

    //轮播图片结束
  }
  .list {
    text-align: center;
    padding-bottom: 80px;
  }
  .list-data {
    margin: 30px auto 0px auto;
    width: 690px;
    min-height: 1197px;
    /*height: 1197px;*/
    /*height: 920px;*/
    background: #232a35;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    .block {
      margin-top: 32px;
      padding-bottom: 70px;
      font-size: 28px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #adb0c7;
      // line-height: 39px;
    }
  }

  .head {
    width: 690px;
    padding: 24px 12px;
    // margin:32px 0 32px 32px;
    background: #232a35;
    opacity: 1;
    border-radius: 16px 16px 16px 16px;
    padding-left: 30px;
    text-align: left;
    height: 48px;
    font-size: 32px;
    font-family: SF Pro Text-Medium, SF Pro Text;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    line-height: 48px;
    span {
      font-size: 26px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #b2b7c2;
      line-height: 36px;
    }
  }
  .xian {
    border-bottom: none !important;
  }
  .list-height {
    min-height: 1197px;
    .content_center {
      text-align: left;
      padding: 40px 0px 40px 0px;
      font-size: 26px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #adb0c7;
      line-height: 36px;
      border-bottom: 1px solid #3c485c;
      margin: 0px 32px;
      div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 16px;
        height: 44px;
        line-height: 44px;
        font-size: 28px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.55);
      }
      span {
        padding-bottom: 10px;
        width: 447px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
        float: right;
        height: 44px;
        font-size: 28px;
        font-family: SF Pro Text-Regular, SF Pro Text;
        font-weight: 400;
        color: #00a870;
        padding-left: 32px;
        line-height: 44px;
      }
      .black {
        height: 44px;
        font-size: 28px;
        font-family: SF Pro Text-Regular, SF Pro Text;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.9);
        line-height: 44px;
        padding-left: 32px;
      }
      span:nth-child(4) {
        color: #2c3852 !important;
      }
      span:nth-child(5) {
        color: #2c3852 !important;
      }
      img {
        width: 48px;
        height: 48px;
        float: right;
        vertical-align: center !important;
      }
    }
  }
}
</style>
